import type { HTMLAttributes } from 'react';
import { P } from '@paypoteam/ui-components/P';

import { cn } from '@/lib/utils';

import type { NumberDataType } from '../DataInNumbersSection.types';

export interface NumberItemProps extends HTMLAttributes<HTMLDivElement> {
    itemData: NumberDataType;
}

export default function NumberItem({ itemData, className }: NumberItemProps) {
    return (
        <div
            className={cn(
                `flex w-[inherit] flex-col items-center pb-6 lg:w-1/3`,
                className,
            )}
        >
            <P
                weight="bold"
                className="font-secondary text-[88px] leading-[1.2]"
            >
                {itemData.data}
            </P>

            <P
                weight="bold"
                className="text-center font-secondary text-md md:text-lg"
            >
                {itemData.description}
            </P>
        </div>
    );
}
